import { isEmptyObject, isNotDefined } from '@sgme/fp';
import classNames from 'classnames';
import { useData } from 'components/common-form/hooks/useData';
import { useFieldMetadata } from 'components/common-form/hooks/useFieldMetadata';
import { IntlKey } from 'locales';
import type { TimeSeriesGraphFieldData, TimeSeriesGraphFieldMetadata } from 'models/forms/fields';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { correlationGraphSelected } from 'state/quotes/selectedCorrelationGraph/selectedCorrelationGraph.action';
import { getSelectedCorrelationGraphByTabId } from 'state/selectors';
import { AppState } from 'state/state.model';
import { isQuoteWorkspaceType } from 'state/workspaces/model';

import type { ProductNodeBuilderProps } from '../../ProductNodeBuilder.model';
import { CorrCarryBackTestGraph } from './Graphs/CorrCarryBacktestGraph';
import { HistCorrelationsGraph } from './Graphs/HistCorrelationsGraph';
import { ConnectedSaveButton } from './shared/SaveButton';

export const TimeSeriesGraphField: FC<ProductNodeBuilderProps> = props => {
  const { node, tabId, tabIndex, workspaceType } = props;
  const dispatch = useDispatch();
  const selectedGraph = useSelector((state: AppState) => getSelectedCorrelationGraphByTabId(state, tabId));
  const [data] = useData<TimeSeriesGraphFieldData>(node.id);
  const fieldMetadata = useFieldMetadata<TimeSeriesGraphFieldMetadata>(node.id);

  if (isNotDefined(data) || isEmptyObject(data?.timeSeries)) {
    return null;
  }

  return (
    <div className="d-flex flex-column">
      <div className="d-flex justify-content-between">
        <ul className="nav nav-xl">
          {fieldMetadata?.availableGraphs.map(graph => (
            <li key={graph} className="nav-item" onClick={() => dispatch(correlationGraphSelected(tabId, graph))}>
              <a className={classNames('nav-link', { active: selectedGraph === graph })}>
                <FormattedMessage id={`graph.${graph}` as IntlKey} />
              </a>
            </li>
          ))}
        </ul>
        {isQuoteWorkspaceType(workspaceType) && <ConnectedSaveButton formId={tabId} workspace={workspaceType} />}
      </div>
      {selectedGraph === 'HistoricalCorrelations' && (
        <HistCorrelationsGraph
          tabIndex={tabIndex}
          tabId={tabId}
          data={data}
          useOppositeInterpolation={fieldMetadata?.useOppositeInterpolation}
        />
      )}
      {selectedGraph === 'CorrelCarryBacktest' && (
        <CorrCarryBackTestGraph tabIndex={tabIndex} tabId={tabId} data={data} />
      )}
    </div>
  );
};
